import { useQuery } from "@tanstack/react-query";

import { getStorefrontLegal } from "../services/frontend/storefront-apis";

const useStorefrontLegal = (enabled) =>
  useQuery({
    queryKey: ["storefrontLegal"],
    queryFn: getStorefrontLegal,
    enabled,
    staleTime: 30 * 1000,
  });

export default useStorefrontLegal;
